import type { RouteRecordRaw } from 'vue-router';
import { allCustomerReview } from '@/pages/customer-review/route';
import { allReviews } from '@/pages/reviews/route';

export const reviewRoutes: RouteRecordRaw = {
  path: '/review',
  component: () => import('@/layouts/main.vue'),
  meta: {
    requireAuth: true,
    requireStoreId: true,
  },
  children: [
    ...allCustomerReview,
    ...allReviews,
  ],
};
